var _defs, _g, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJacket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c{fill:none;}.a{stroke:#4c4c4e;stroke-linecap:round;stroke-linejoin:round;}.b{fill:#4c4c4e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.411 4.263)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M28.067,3.125l3.98,4.008v4l-2.029,2,2.029,3S23.9,29.149,17.8,33.19",
    transform: "translate(-1.515 -3.125)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.8,42.412V26.4c.815-1.108,1.543-2.225,2.237-3.342.286-.46.546-.929.815-1.381",
    transform: "translate(-1.515 3.632)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M29.218,3.125a56.72,56.72,0,0,1-7.206,25.307A56.72,56.72,0,0,1,14.806,3.125H29.218",
    transform: "translate(-2.675 -3.125)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.92,3.125,11.931,7.133v4l2.029,2-2.029,3A98.956,98.956,0,0,0,22.337,29.78",
    transform: "translate(-3.789 -3.125)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M33.232,14.863V44.894H20",
    transform: "translate(-0.663 1.151)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.2,6.062,8.872,8.68A4.98,4.98,0,0,0,6.063,13.14V46.1h6.07",
    transform: "translate(-6.063 -2.055)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M28.069,6.062,33.4,8.68a4.98,4.98,0,0,1,2.809,4.459V46.1h-6.07",
    transform: "translate(2.463 -2.055)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.462,14.863V44.894H23.695",
    transform: "translate(-4.358 1.151)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.462,26.6h6.1v6.011h-6.1",
    transform: "translate(-4.358 5.427)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M31.242,26.6h-6.1v6.011h6.1",
    transform: "translate(1.327 5.427)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 1.015,
    cy: 0.998,
    rx: 1.015,
    ry: 0.998,
    transform: "translate(19.337 32.035)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 1.015,
    cy: 0.998,
    rx: 1.015,
    ry: 0.998,
    transform: "translate(19.337 38.038)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 56,
    height: 55.067
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJacket);
export default __webpack_public_path__ + "static/media/Jacket.21b03efba599d7b61deea9e394e4805e.svg";
export { ForwardRef as ReactComponent };